"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlocksApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class BlocksApi extends runtime.BaseAPI {
    /**
     * Get a specific block by burnchain block hash
     * Get block
     */
    async getBlockByBurnBlockHashRaw(requestParameters, initOverrides) {
        if (requestParameters.burnBlockHash === null || requestParameters.burnBlockHash === undefined) {
            throw new runtime.RequiredError('burnBlockHash', 'Required parameter requestParameters.burnBlockHash was null or undefined when calling getBlockByBurnBlockHash.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/block/by_burn_block_hash/{burn_block_hash}`.replace(`{${"burn_block_hash"}}`, encodeURIComponent(String(requestParameters.burnBlockHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BlockFromJSON(jsonValue));
    }
    /**
     * Get a specific block by burnchain block hash
     * Get block
     */
    async getBlockByBurnBlockHash(requestParameters, initOverrides) {
        const response = await this.getBlockByBurnBlockHashRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific block by burn chain height
     * Get block
     */
    async getBlockByBurnBlockHeightRaw(requestParameters, initOverrides) {
        if (requestParameters.burnBlockHeight === null || requestParameters.burnBlockHeight === undefined) {
            throw new runtime.RequiredError('burnBlockHeight', 'Required parameter requestParameters.burnBlockHeight was null or undefined when calling getBlockByBurnBlockHeight.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/block/by_burn_block_height/{burn_block_height}`.replace(`{${"burn_block_height"}}`, encodeURIComponent(String(requestParameters.burnBlockHeight))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BlockFromJSON(jsonValue));
    }
    /**
     * Get a specific block by burn chain height
     * Get block
     */
    async getBlockByBurnBlockHeight(requestParameters, initOverrides) {
        const response = await this.getBlockByBurnBlockHeightRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific block by hash
     * Get block
     */
    async getBlockByHashRaw(requestParameters, initOverrides) {
        if (requestParameters.hash === null || requestParameters.hash === undefined) {
            throw new runtime.RequiredError('hash', 'Required parameter requestParameters.hash was null or undefined when calling getBlockByHash.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/block/{hash}`.replace(`{${"hash"}}`, encodeURIComponent(String(requestParameters.hash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BlockFromJSON(jsonValue));
    }
    /**
     * Get a specific block by hash
     * Get block
     */
    async getBlockByHash(requestParameters, initOverrides) {
        const response = await this.getBlockByHashRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific block by height
     * Get block
     */
    async getBlockByHeightRaw(requestParameters, initOverrides) {
        if (requestParameters.height === null || requestParameters.height === undefined) {
            throw new runtime.RequiredError('height', 'Required parameter requestParameters.height was null or undefined when calling getBlockByHeight.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/block/by_height/{height}`.replace(`{${"height"}}`, encodeURIComponent(String(requestParameters.height))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BlockFromJSON(jsonValue));
    }
    /**
     * Get a specific block by height
     * Get block
     */
    async getBlockByHeight(requestParameters, initOverrides) {
        const response = await this.getBlockByHeightRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all recently mined blocks
     * Get recent blocks
     */
    async getBlockListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/block`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BlockListResponseFromJSON(jsonValue));
    }
    /**
     * Get all recently mined blocks
     * Get recent blocks
     */
    async getBlockList(requestParameters, initOverrides) {
        const response = await this.getBlockListRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.BlocksApi = BlocksApi;
//# sourceMappingURL=BlocksApi.js.map